import { connect } from 'react-redux';
import WorkingHours from '../../components/working-hours/working-hours';
import {
  fetchPlants,
  fetchWorkingHours,
  updateWorkingHours,
  setDefaultWorkingHours,
  restoreWorkingHours,
} from './working-hours-actions';

const mapDispatchToProps = {
  fetchPlants,
  fetchWorkingHours,
  updateWorkingHours,
  setDefaultWorkingHours,
  restoreWorkingHours,
};

const mapStateToProps = state => ({
  serviceCenterId: state.serviceCenter.activeServiceCenter,
  plants: state.workingHours.plants,
  data: state.workingHours.data,
  error: state.workingHours.error,
  isLoading: state.workingHours.isLoading,
  updateSuccess: state.workingHours.updateSuccess,
  isFetching: state.workingHours.isFetching,
  isRestoring: state.workingHours.isRestoring,
});

export default connect(mapStateToProps, mapDispatchToProps)(WorkingHours);
